import { itemGroupsActionTypes } from "../../../../actionTypes/items/categories/itemGroups/itemGroups.actionTypes";

const initialState = {
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  itemGroups: [],
};

const itemGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case itemGroupsActionTypes.START_GET_ITEM_GROUPS:
    case itemGroupsActionTypes.START_CONNECT_ITEM_GROUP_WITH_CATEGORY:
    case itemGroupsActionTypes.START_DISCONNECT_ITEM_GROUP_FROM_CATEGORY:
    case itemGroupsActionTypes.START_UPDATE_DISPLAY_ORDER:
    case itemGroupsActionTypes.START_UPDATE_ITEM_GROUP_IMAGE:
    case itemGroupsActionTypes.START_DELETE_ITEM_GROUP_IMAGE:
      return setStateLoading(state);

    case itemGroupsActionTypes.GET_ITEM_GROUPS_SUCCESS:
      return setItemGroups(state, action);

    case itemGroupsActionTypes.CONNECT_ITEM_GROUP_WITH_CATEGORY_SUCCESS:
    case itemGroupsActionTypes.DISCONNECT_ITEM_GROUP_FROM_CATEGORY_SUCCESS:
    case itemGroupsActionTypes.UPDATE_DISPLAY_ORDER_SUCCESS:
    case itemGroupsActionTypes.UPDATE_ITEM_GROUP_IMAGE_SUCCESS:
    case itemGroupsActionTypes.DELETE_ITEM_GROUP_IMAGE_SUCCESS:
      return setStateSuccess(state);

    case itemGroupsActionTypes.GET_ITEM_GROUPS_FAILURE:
    case itemGroupsActionTypes.CONNECT_ITEM_GROUP_WITH_CATEGORY_FAILURE:
    case itemGroupsActionTypes.DISCONNECT_ITEM_GROUP_FROM_CATEGORY_FAILURE:
    case itemGroupsActionTypes.UPDATE_DISPLAY_ORDER_FAILURE:
    case itemGroupsActionTypes.UPDATE_ITEM_GROUP_IMAGE_FAILURE:
    case itemGroupsActionTypes.DELETE_ITEM_GROUP_IMAGE_FAILURE:
      return setStateFailure(state, action);

      case itemGroupsActionTypes.UPDATE_ITEM_GROUPS_LOCALLY: // Handle local updates
      return {
        ...state,
        itemGroups: action.data, // Update the itemGroups with the provided data
      };
      
    default:
      return state;
  }
};

// Helper Functions
const setStateLoading = (state) => ({
  ...state,
  stateInfo: {
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  },
});

const setStateSuccess = (state) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setStateFailure = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: true,
    error: action.error,
  },
});

const setItemGroups = (state, action) => ({
  ...state,
  itemGroups: action.data,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

export default itemGroupsReducer;
